export default {
  paginaAtual: 1,
  estaCarregando: false,
  todosItensCarregados: false,
  totalItens: null,
  lista:[],
  listaPessoas: [],
  pessoaSelecionadaId: null,
  order: '',
  direcao: '',
  objPessoa: {
    bairro_endereco: null,
    categoria: [],
    cd_tipo: null,
    cep_endereco: null,
    cnpj_cpf: null,
    complemento_endereco: null,
    data_cadastramento: null,
    endereco: null,
    excluido: null,
    franqueada: null,
    id: null,
    id_importado: null,
    negativado: null,
    nome_contato: null,
    estado_civil: null,
    sexo: null,
    telefone_preferencial: null,
    estado: [],
    cidade: [],
    tipo_pessoa: 'F',
    data_nascimento: ''
  },
  responsavel: {
    bairro_endereco: null,
    categoria: [],
    cd_tipo: null,
    cep_endereco: null,
    cnpj_cpf: null,
    complemento_endereco: null,
    data_cadastramento: null,
    endereco: null,
    excluido: null,
    franqueada: null,
    id: null,
    id_importado: null,
    negativado: null,
    nome_contato: '',
    estado_civil: null,
    sexo: null,
    telefone_preferencial: null,
    telefone_contato: null,
    telefone_profissional: null,
    email_preferencial: null,
    email_contato: null,
    email_profissional: null,
    estado: [],
    cidade: [],
    tipo_pessoa: 'F',
    plano_conta: null,
    data_nascimento: '',
    numero_identidade: '',
    orgao_emissor: '',
    nome_fantasia: '',
    razao_social: '',
    inscricao_estadual: '',
    inscricao_municipal: '',
    agencia: '',
    conta: '',
    telefona_preferencial: '',
    observacao: ''
  },

  filtros: {
    alunos: false
  },

  filtroRapido: {
    tipoPessoa: 'F',
    nome: '',
    telefone: '',
    cpf: '',
    cnpj: ''
  }
}
